import { Link } from "react-router-dom";
import { useState } from "react";
import "../styles/LandingPage.css";
import "./Patients.css";
import Header from "../components/Header/Header";
import { usePatients } from "../hooks/usePatients";
import PatientIcon from "../components/Icons/PatientIcon";
import Loading from "../components/Loading";
import PatientCard from "../components/PatientCard";
import Error from "../components/Error";
import NotFound from "../components/NotFound";

const RPMList = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const { data, isLoading, isError, error } = usePatients();

  // Filter patients based on search term (case-insensitive)
  const filteredData = Array.isArray(data)
    ? data.filter((patient) =>
        patient.name.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : [];

  return (
    <>
      <Header
        pageTitle={
          <PatientIcon />
        }
      />
      {isLoading && <Loading />}
      {isError && (
        <Error
          error={error?.message || "Failed to load patients. Please try again."}
        />
      )}
      {!isLoading && !isError && data.length === 0 && (
        <NotFound text={"No patients found."} />
      )}
      {data && data.length > 0 && (
        <div
          className="pb-4"
          style={{
            height: "calc(100vh - 96px)",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          <div className="px-4">
            <div className="mb-4 mt-2">
              <input
                type="text"
                placeholder="Search patients by name..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            {filteredData?.length > 0 && (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                {filteredData.map((patient) => (
                  <PatientCard key={patient.patient_id} patient={patient} />
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default RPMList;
